document.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded");
  // product forms
  const productForms = document.querySelectorAll('[id^="AddToCartForm-"]');
  //
  productForms.forEach((form) => {
    const productId = form.getAttribute("data-productid");
    const productData = window.thatWorks.productsAnywhere[productId];
    const variantButtons = form.querySelectorAll(".variant-input label");
    //
    // add disabled to any varaints that are unavailable
    variantButtons.forEach((button) => {
      // get variant id
      const variantData = productData.variants.find(
        (v) =>
          v.title ===
          button.closest(".variant-input").querySelector("input").value
      );

      // if variant unavailable, disable button
      if (!variantData.available) {
        button.closest(".variant-input").querySelector("input").disabled = true;
        button.classList.add("disabled");
      }
    });
  });

  // listen for global theme customn event for variant change and update the form field accordingly
  document.addEventListener("variant:change", (event) => {
    const variant = event.detail.variant;
    // find relvant product from data array given variant id
    const productId = Object.keys(window.thatWorks.productsAnywhere).find(
      (id) =>
        window.thatWorks.productsAnywhere[id].variants.find(
          (v) => v.id === variant.id
        )
    );

    document.querySelector(`#variant-field_${productId}`).value = variant.id;
  });

  // Modal and form handling
  const modal = document.getElementById("additional-options-modal");
  const additionalOptionsForm = document.getElementById(
    "additional-options-form"
  );
  const nationsLeaguesCheckboxes = document.querySelectorAll(
    'input[name="nations_leagues"]'
  );
  let currentForm = null;

  // Handle checkbox limit
  nationsLeaguesCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const checkedBoxes = document.querySelectorAll(
        'input[name="nations_leagues"]:checked'
      );
      if (checkedBoxes.length > 3) {
        this.checked = false;
        alert("You can only select up to 3 nations/leagues to avoid.");
      }
    });
  });

  // Handle modal close
  document.getElementById("cancel-options").addEventListener("click", () => {
    modal.classList.add("tw-hidden");
  });

  // Handle form submission
  additionalOptionsForm.addEventListener("submit", (e) => {
    e.preventDefault();

    // Get selected nations/leagues
    const selectedNations = Array.from(
      document.querySelectorAll('input[name="nations_leagues"]:checked')
    ).map((cb) => cb.value);

    // Get other form values
    const specificTeams = document.getElementById("specific-teams").value;
    const additionalInfo = document.getElementById("additional-info").value;

    console.log({ selectedNations, specificTeams, additionalInfo });
    const productId = currentForm.getAttribute("data-productid");

    currentForm.querySelector(`#nations-leagues_${productId}`).value =
      selectedNations.join(", ");
    currentForm.querySelector(`#specific-teams_${productId}`).value =
      specificTeams;
    currentForm.querySelector(`#additional-info-field_${productId}`).value =
      additionalInfo;

    // Submit the original form
    currentForm.submit();
  });

  function prefillFromForm(form) {
    const productId = form.getAttribute("data-productid");
    const teamsField = form.querySelector(`#specific-teams_${productId}`);
    const teams = teamsField ? teamsField.value.trim() : "";
    if (teams) document.getElementById("specific-teams").value = teams;

    // Tick any popup option that matches a pick or an already-chosen nation/county, then fire
    // change so gaa-county-picker.js updates its pills and counter. It re-syncs on the form's
    // reset in a setTimeout(0), so tick after that.
    const nationsField = form.querySelector(`#nations-leagues_${productId}`);
    const wanted = []
      .concat(teams ? teams.split(",") : [])
      .concat(nationsField && nationsField.value ? nationsField.value.split(",") : [])
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);
    if (!wanted.length) return;
    setTimeout(() => {
      let ticked = 0;
      document.querySelectorAll('input[name="nations_leagues"]').forEach((cb) => {
        if (ticked >= 3 || cb.closest("[hidden]")) return;
        if (wanted.indexOf(String(cb.value).trim().toLowerCase()) > -1) {
          cb.checked = true;
          ticked += 1;
          cb.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }, 0);
  }

  // Intercept add-to-cart action to present more options in a modal
  const addToCartForms = document.querySelectorAll("form[action='/cart/add']");
  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      currentForm = form;

      // Reset form
      additionalOptionsForm.reset();

      // Pre-fill the popup with what is already in this form's hidden avoid fields (on the
      // homepage, the teams picked in the avoid picker). Must run after reset(), which empties
      // the textarea, or a customer who clicks straight through wipes their picks. On a product
      // page these fields are empty when the popup first opens, so nothing changes there.
      prefillFromForm(form);

      // Show modal
      modal.classList.remove("tw-hidden");
    });
  });

  // data-section-id
  // toggle which product to show.
  const productSwitcher = document.querySelectorAll(`[data-product-toggle]`);
  productSwitcher.forEach((button) => {
    button.addEventListener("click", () => {
      const productId = button.getAttribute("data-product-toggle");
      //   hide sections then show the one we want
      document.querySelectorAll(`.product-section[data-section-id]`).forEach((section) => {
        section.classList.add("tw-hidden");
      });
      document
        .querySelector(`[data-section-id="${productId}"]`)
        .classList.remove("tw-hidden");

      window.dispatchEvent(new Event("resize"));
    });
  });
});
